'use client';

import { tracking } from '@/hotdesk-ui/services/tracking.service';
import { useEffect } from 'react';
export type WorkspaceDiscoveryTrackingProps = {
  workspaceId: string | number | undefined;
  workspaceName: string;
  workspaceAmenities: string[];
  listingIds?: (string | number)[];
};

/**
 * Fires PostHog discovery events when the workspace details page loads:
 * - workspace_details_viewed  (id, name, amenities)
 * - workspace_listings_viewed (id, listing_ids, source)
 */
export default function WorkspaceDiscoveryTracking({
  workspaceId,
  workspaceName,
  workspaceAmenities,
  listingIds
}: WorkspaceDiscoveryTrackingProps) {
  useEffect(() => {
    if (workspaceId == null || workspaceId === '') return;
    const screenUrl = typeof window !== 'undefined' ? window.location.href : '';
    tracking.onWorkspaceDetailsViewed(workspaceId, workspaceName, workspaceAmenities, screenUrl);
    tracking.onWorkspaceListingsViewed(workspaceId, screenUrl, listingIds);
  }, [workspaceId, workspaceName, workspaceAmenities]);
  return null;
}